module.exports = __webpack_public_path__ + "media/images/athletes/3458-44721bd99c7ae629344021166cb9a9e7.png";